var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 15.5L10.25 11.9L13.85 15.5L15.25 14.1L11.65 10.5L15.25 6.9L13.85 5.5L10.25 9.1L6.65 5.5L5.25 6.9L8.85 10.5L5.25 14.1L6.65 15.5ZM10.25 20.5C8.86667 20.5 7.56667 20.2375 6.35 19.7125C5.13333 19.1875 4.075 18.475 3.175 17.575C2.275 16.675 1.5625 15.6167 1.0375 14.4C0.5125 13.1833 0.25 11.8833 0.25 10.5C0.25 9.11667 0.5125 7.81667 1.0375 6.6C1.5625 5.38333 2.275 4.325 3.175 3.425C4.075 2.525 5.13333 1.8125 6.35 1.2875C7.56667 0.7625 8.86667 0.5 10.25 0.5C11.6333 0.5 12.9333 0.7625 14.15 1.2875C15.3667 1.8125 16.425 2.525 17.325 3.425C18.225 4.325 18.9375 5.38333 19.4625 6.6C19.9875 7.81667 20.25 9.11667 20.25 10.5C20.25 11.8833 19.9875 13.1833 19.4625 14.4C18.9375 15.6167 18.225 16.675 17.325 17.575C16.425 18.475 15.3667 19.1875 14.15 19.7125C12.9333 20.2375 11.6333 20.5 10.25 20.5ZM10.25 18.5C12.4833 18.5 14.375 17.725 15.925 16.175C17.475 14.625 18.25 12.7333 18.25 10.5C18.25 8.26667 17.475 6.375 15.925 4.825C14.375 3.275 12.4833 2.5 10.25 2.5C8.01667 2.5 6.125 3.275 4.575 4.825C3.025 6.375 2.25 8.26667 2.25 10.5C2.25 12.7333 3.025 14.625 4.575 16.175C6.125 17.725 8.01667 18.5 10.25 18.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.80fe85d4.svg";
export { ForwardRef as ReactComponent };